import { defineMessages } from 'react-intl'

export const HEALTH_PLAN_INFO_MESSAGES = defineMessages({
  profileHeader: {
    defaultMessage: 'Health plan information',
    description: 'Health plan info - Profile header text',
  },
  teenProfileHeader: {
    defaultMessage: "{patientName}'s health plan information",
    description: 'Health plan info - Profile header text for teen dependent',
  },
  primaryHealthPlanHeader: {
    defaultMessage: 'Primary health plan',
    description: 'Health plan info - Profile header text',
  },
  secondaryHealthPlanHeader: {
    defaultMessage: 'Secondary health plan',
    description: 'Health plan info - Profile header text',
  },
  confirmPlanHeader: {
    defaultMessage: 'Confirm health plan',
    description: 'Health plan info - Confirm health plan header text',
  },
  newPlanHeader: {
    defaultMessage: 'Add a health plan',
    description: 'Health plan info - Add health plan header text',
  },
  subHeader: {
    defaultMessage: 'Enter the information exactly as it appears on your insurance ID card.',
    description: 'Health plan info - SubHeader text',
  },
  subHeader2: {
    defaultMessage:
      'You may be responsible for co-pays, co-insurances, and deductibles for Lyra services covered by your health plan. <link>Learn more</link>.',
    description: 'Health plan info - SubHeader line 2 text',
  },
  subHeaderOCR: {
    defaultMessage:
      "As part of your health plan's cost sharing, you may be responsible for co-pays, co-insurance, and deductibles for {isTeenDependent, select, true {{dependentFirstName}’s } other {}}Lyra services. <link>Learn more</link>",
    description: 'Health plan info - SubHeader line 2 text',
  },
  subHeaderEAPToHPIEmail: {
    defaultMessage:
      'We need your health plan information for any Lyra care beyond your covered sessions. <link>Learn more</link> about your out-of-pocket costs.',
    description: 'Health plan info - SubHeader for EAP to HPI email text',
  },
  zeroDollarCostShareSubheader: {
    defaultMessage: 'Add your eligible health plan to receive Lyra care at no cost to you. <link>Learn more</link>',
    description: 'Health plan info - SubHeader text when the customer has zero dollar cost share',
  },
  zeroDollarCostShareFromEmailSubheader: {
    defaultMessage:
      'Add your eligible health plan to receive Lyra care beyond your covered sessions at no cost to you. <link>Learn more</link>',
    description: 'Health plan info - SubHeader text when the customer has zero dollar cost share and comes from email',
  },
  firstName: {
    defaultMessage: 'First name',
    description: 'Health plan info - First name label',
  },
  lastName: {
    defaultMessage: 'Last name',
    description: 'Health plan info - Last name label',
  },
  healthPlanPicker: {
    defaultMessage: 'Health plan',
    description: 'Health plan info - Health plan picker label',
  },
  legalFirstName: {
    defaultMessage: 'Legal first name',
    description: 'Health plan info - Legal first name label',
  },
  legalLastName: {
    defaultMessage: 'Legal last name',
    description: 'Health plan info - Legal last name label',
  },
  healthPlanName: {
    defaultMessage: 'Health plan name',
    description: 'Health plan info - Health plan name label',
  },
  primaryHealthPlanPickerTitle: {
    defaultMessage: 'Primary health plan',
    description: 'Health plan info - Health plan picker label',
  },
  secondaryHealthPlanPickerTitle: {
    defaultMessage: 'Secondary health plan',
    description: 'Health plan info - Health plan picker label',
  },
  primaryHealthPlanPickerSubtitle: {
    defaultMessage: 'Select the main insurance plan covering your health care needs.',
    description: 'Health plan info - Health plan picker label',
  },
  secondaryHealthPlanPickerSubtitle: {
    defaultMessage: 'Select a second insurance plan that covers your health care needs.',
    description: 'Health plan info - Health plan picker label',
  },
  profilePageHealthPlanPickerSubtitle: {
    defaultMessage: 'Please add your information exactly as it appears on your insurance card.',
    description: 'Health plan info - Health plan picker label',
  },
  dobWeb: {
    defaultMessage: 'Date of birth',
    description: 'Health plan info - Date of birth web label',
  },
  dobNative: {
    defaultMessage: 'Date of birth (MM/DD/YYYY)',
    description: 'Health plan info - Date of birth native label',
  },
  memberId: {
    defaultMessage: 'Member or subscriber ID',
    description: 'Health plan info - Member or subscriber ID label',
  },
  add: {
    defaultMessage: 'Add',
    description: 'Add button text',
  },
  recheck: {
    defaultMessage: 'Recheck',
    description: 'Recheck button text for retrying health plan verification',
  },
  enrollInSelfPay: {
    defaultMessage: 'Enroll in self-pay',
    description: 'Button text to opt into self-pay when health plan verification fails',
  },
  save: {
    defaultMessage: 'Save',
    description: 'Health plan info - Save button text',
  },
  next: {
    defaultMessage: 'Next',
    description: 'Health plan info - Next button text',
  },
  continue: {
    defaultMessage: 'Continue',
    description: 'Health plan info - Continue button text',
  },
  remove: {
    defaultMessage: 'Remove',
    description: 'Health plan info - Remove button text',
  },
  memberIdTooltip: {
    defaultMessage: 'The Member ID Number is listed on the left side of your medical plan card.',
    description: 'Health plan info - Member id tooltip content',
  },
  primaryHeader: {
    defaultMessage: 'Let’s get started',
    description: 'Header text for a page to enter health plan information',
  },
  secondaryHeader: {
    defaultMessage: 'Add a secondary health plan',
    description: 'Header text for a page to enter health plan information',
  },
  primarySubheader: {
    defaultMessage:
      'To connect you with quality care, we will first check your health plan to determine your coverage. Cost-sharing may apply depending on your plan. <link>Learn more</link>.',
    description: 'Subheader text for a page to enter health plan information',
  },
  secondarySubheader: {
    defaultMessage:
      'Let us know if you are insured by more than one health plan so that we can determine your coverage and recommend different care options. Cost-sharing may apply depending on your plan. <link>Learn more</link>.',
    description: 'Subheader text for a page to enter health plan information',
  },
  costSharingSubheader: {
    defaultMessage: 'Cost-sharing may apply depending on your plan. <link>Learn more</link>.',
    description:
      'Subheader text for a page to enter health plan information. Contains a link for copay/coinsurance terms and conditions',
  },
  secondaryHealthPlanQuestion: {
    defaultMessage: 'Are you also covered by a secondary health plan? []()',
    description: 'Text above a yes/no radio button group asking the user if they have a secondary health plan',
  },
  secondaryHealthPlanTooltipHeader: {
    defaultMessage: 'What is a secondary health plan?',
    description: 'Header text for tooltip describing what a secondary health plan is',
  },
  secondaryHealthPlanTooltipContent: {
    defaultMessage:
      'You may have more than one health plan if you are covered by an employer, school, or family member. ',
    description: 'Content text for tooltip describing what a secondary health plan is',
  },
  secondaryHealthPlanWarning: {
    defaultMessage:
      'If you don’t have a secondary health plan, your primary health plan must be sponsored by the organization that grants you access to Lyra.',
    description: 'Banner message displayed as a warning to inform the user they must have a Lyra-supported health plan',
  },
  healthPlanTypeLabel: {
    defaultMessage: 'Type',
    description: 'Label text of a health plan dropdown list',
  },
  otherHealthPlan: {
    defaultMessage: 'Other',
    description: 'Text displayed when the user selects in a dropdown list that they can’t find their health plan',
  },
  noSecondaryHealthPlan: {
    defaultMessage: 'I don’t have a secondary health plan',
    description: 'Button text for a user to opt out of adding a secondary health plan',
  },
  healthPlanSelectorLabel: {
    defaultMessage: 'Select a health plan',
    description: 'Label of a search field that can be used to select a health plan',
  },
  secondaryHealthPlanDescription: {
    defaultMessage: 'A secondary health insurance plan may be able to cover expenses that your primary plan doesn’t.',
    description: 'Subheader text on a profile page where a user can add a secondary health plan',
  },
  primary: {
    defaultMessage: 'Primary',
    description: 'Part of a header that shows a health plan and specifies that it is a primary health plan',
  },
  secondary: {
    defaultMessage: 'Secondary',
    description: 'Part of a header that shows a health plan and specifies that it is a secondary health plan',
  },
  healthPlanRemovalHeader: {
    defaultMessage: 'Are you sure?',
    description: 'Header of a modal for the user to confirm removing their health plans',
  },
  healthPlanRemovalSubheader: {
    defaultMessage:
      'You must have a Lyra-integrated health plan present. Removing this will automatically remove both health plans.',
    description: 'Subheader of a modal for the user to confirm removing their health plans',
  },
  enterInformationManually: {
    defaultMessage: 'Enter information manually',
    description: 'Button text to expand collapsible section for manual entry',
  },
  reviewYourInformation: {
    defaultMessage: 'Review your information',
    description: 'Button text to expand collapsible section after OCR completes',
  },
  reviewPatientInformation: {
    defaultMessage: "Review {patientName}'s information",
    description: 'Button text to expand collapsible section after OCR completes for teen dependent',
  },
  uploadHealthInsuranceCard: {
    defaultMessage: 'Upload {isTeenDependent, select, true {their} other {your}} health insurance card',
    description: 'Header text for health insurance card upload section',
  },
  uploadPatientHealthInsuranceCard: {
    defaultMessage: "Upload {patientName}'s health insurance card",
    description: 'Header text for health insurance card upload section',
  },
  uploadOptional: {
    defaultMessage: 'OPTIONAL',
    description: 'Label indicating upload section is optional',
  },
  uploadDescription: {
    defaultMessage:
      "We'll automatically verify {isTeenDependent, select, true {the} other {your}} information with photos of {isTeenDependent, select, true {their} other {your}} card.",
    description: 'Description text for health insurance card upload',
  },
  frontOfCard: {
    defaultMessage: 'Front of card',
    description: 'Label for front of insurance card upload',
  },
  backOfCard: {
    defaultMessage: 'Back of card',
    description: 'Label for back of insurance card upload',
  },
  frontOfCardUploaded: {
    defaultMessage: 'Front of card uploaded',
    description: 'Toast text when front of card is uploaded successfully',
  },
  backOfCardUploaded: {
    defaultMessage: 'Back of card uploaded',
    description: 'Toast text when back of card is uploaded successfully',
  },
  bothCardsUploadedAndScanned: {
    defaultMessage: 'Images uploaded and scanned',
    description: 'Toast text when both front and back cards are uploaded successfully',
  },
  uploadErrorMessage: {
    defaultMessage:
      'We could not upload your image. Accepted file types are JPG, PNG, PDF, and HEIC. Maximum file size is 5 MB. Try again or enter your information manually below.',
    description: 'Error message displayed when health plan card upload fails due to file validation',
  },
  uploadErrorMessageNoManualEntry: {
    defaultMessage:
      'We could not upload your image. Accepted file types are JPG, PNG, PDF, and HEIC. Maximum file size is 5 MB. Try again below.',
    description: 'Error message displayed when health plan card upload fails for customers without manual entry option',
  },
  ocrScanErrorMessage: {
    defaultMessage: 'We could not scan your uploaded image. Try again or enter your information manually.',
    description: 'Error message displayed when OCR scanning fails to read the health plan card',
  },
  ocrScanErrorMessageNoManualEntry: {
    defaultMessage:
      'We could not scan your uploaded image. Try again or you can select self-pay for now and follow up with <link>care@lyrahealth.com</link>.',
    description:
      'Error message displayed when OCR scanning fails to read the health plan card for customers without manual entry option',
  },
  memberIdSublabel: {
    defaultMessage:
      'Enter your ID as shown on your card, using all letters and numbers without spaces or special characters.',
    description: 'Sublabel helper text for member ID field',
  },
  healthPlanNoMatch: {
    defaultMessage:
      'We are having trouble matching your information to a supported health plan. Please ensure that you entered your information correctly. For more help, see our <a1>FAQ</a1> or contact us at <a2>{careTeamEmail}</a2>.',
    description:
      'Banner message informing the user that Lyra was not able to match their plan to a supported health plan and to contact Lyra for any needed assistance',
  },
  healthPlanVerified: {
    defaultMessage: 'Health plan verified',
    description: 'Toast text when health plan form is successfully submitted and verified',
  },
  registrationDataMismatchBanner: {
    defaultMessage:
      'It looks like your name and date of birth may not match our records. Confirm your details and continue, or <link>contact us</link>.',
    description: 'Warning banner displayed when form values do not match registration data on first submission attempt',
  },
  changeHealthcareResponseErrorMessage: {
    defaultMessage:
      'Your health plan cannot be verified at this time. If you believe this is an error, you can select self-pay for now and follow up with <link>care@lyrahealth.com.</link>',
    description: 'Error message displayed when Change health plan verification fails',
  },
})
